










































































import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import Loader from "@/components/Loader.vue";
import PublisherCreator from "@/components/publisher/PublisherCreator.vue";
import { formatService } from "../../services/format.service";
import { IPublisher } from "../../models/interfaces/publisher/publisher.model.interface";
import { Publisher } from "@/models/publisher/publisher.model";
import { StatusType } from "@/enums/StatusType";

const PublisherModule = namespace("publisherModule");
const PublisherManagementModule = namespace("publisherManagementModule");

@Component({
  components: {
    Loader,
    PublisherCreator
  }
})
export default class PublishersTable extends Vue {
  @PublisherModule.Getter public publishers;
  @PublisherModule.Action public retrievePublishers;
  @PublisherManagementModule.Action public pausePublisher;
  @PublisherManagementModule.Action public setPublisherLive;

  get getPublishers(): IPublisher[] {
    return this.publishers;
  }

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Provide() public items: IPublisher[] = [];

  @Provide()
  public columns = [
    {
      key: "name",
      label: "Publisher",
      sortable: true,
      formatter: (value, key, item) => {
        return item;
      }
    },
    {
      key: "properties.name",
      label: "Properties",
      formatter: (value, key, item) => {
        const properties = item.properties.map((x) => x.name);
        return formatService.commaSeparatedList(properties);
      }
    },
    {
      key: "state",
      label: "Status",
      sortable: true,
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  @Provide() public currentPage = 1;
  @Provide() public perPage = 10;
  @Provide() public totalRows = 0;

  private filter: string | null = null;

  private loading: boolean = true;

  private show: boolean = false;

  private selectedPublisher: IPublisher = new Publisher();

  get modalText(): string {
    if (this.selectedPublisher.state.statusType === StatusType.Live) {
      return `Are you sure you want to pause ${this.selectedPublisher.name}?`;
    }
    return `Are you sure you want to set ${this.selectedPublisher.name} live?`;
  }

  public showModal(publisher: IPublisher) {
    this.selectedPublisher = publisher;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }

  public completeAction() {
    if (this.selectedPublisher.state.statusType === StatusType.Live) {
      this.pausePublisher(this.selectedPublisher).then((result) => {
        this.hideModal();
      });
    } else {
      this.setPublisherLive(this.selectedPublisher).then((result) => {
        this.hideModal();
      });
    }
  }

  public getRowCount(items) {
    return items.length;
  }

  get showPagination(): boolean {
    return this.items.length > this.perPage;
  }

  @Watch("getPublishers.0.publisherId", { deep: true })
  public onPublishersUpdate() {
    this.items = this.getPublishers;
  }

  public updatePublishers() {
    this.loading = true;
    this.retrievePublishers().then((result) => {
      this.items = this.getPublishers;
      this.loading = false;
    });
  }

  public onFiltered(filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }

  public created() {
    this.updatePublishers();
  }
}
